<template>
  <div class="component-container">
    <div class="second-edition" id="second-edition">
      <h3>1LNG Second Edition: Plant and Animal Traits - Downloads and Resources</h3>

      <div class="back-button-wrapper">
        <button type="button" @click.prevent="cancelButton" class="back-button">Back to Main Dashboard</button>
      </div>

      <div class="presentations">
        <h4>Teacher Resources</h4>
        <ul>
         

          <li><a href="https://firebasestorage.googleapis.com/v0/b/ccs-online-prototype.appspot.com/o/activityPresentations%2FAugust%202024%20Updates%2F1LNG-2E_Activities_1-5_08212024.zip?alt=media&token=09e3ca69-5be9-41b1-a752-1fbc4b8c3b0a" target="_blank">Teacher Presentations: Activities 1 - 5</a> - Updated 8/21/2024</li>

          <li><a href="https://firebasestorage.googleapis.com/v0/b/ccs-dev-926a6.appspot.com/o/unitUpdates%2FCerealCityScience_1LNG_Activity1_2023.pdf?alt=media&token=36d1280c-b98d-4dac-99fa-db32b95f6d93">Modified Activity 1 and Observation Log</a> -  Allows the unit to be taught without live fiddler crabs. (Updated 3/31/2023)</li>
          <!-- <li><a href="https://drive.google.com/file/d/1qmJ8JEpkFQrCaTqjTv56JsBfjYwLbxJH/view?usp=sharing" target="_blank">Fiddler Crabs in the Classroom Habitat (Video)</a></li> -->
          
          <li><a href="https://docs.google.com/spreadsheets/d/1RZrQWEcgAu2kxE60cdaDCwpFOj35RFvl_ZiPRYWxAXw/edit?usp=sharing" target="_blank">Teacher Guide Links Spreadsheet</a> - List of all links in the printed Teacher Guide</li>
          <li><a href="https://docs.google.com/spreadsheets/d/1qe8R8GD92WO6dtzWri9pKbKWjAYx2siuRzdE8bcT_6c/edit?gid=1062009112#gid=1062009112">Curriculum Updates Spreadsheet </a> - List with links to updates for your printed Teacher Guide</li>
        </ul>
      </div>

      <div class="presentations">
        <h4>Student Journals &amp; Assessments</h4>
        <p>Please make a master copy for your classroom and save to your Google drive for your classroom.</p>
        <ul>
          <li><a href="https://docs.google.com/presentation/d/1EIVO-YmBSacv2STiFuO_ALTPkgGAiHUu8D-gL06dnL0/copy" target="_blank">1LNG 2nd Edition - Plant and Animal Traits Student Journal</a></li>
          <li><a href="https://drive.google.com/file/d/11LMjpgTffQi-zU4E7bRet2SaajYo1zjR/view" target="_blank">1LNG 2nd Edition - Plant and Animal Traits Student Journal Answer Key</a></li>
          <li><a href="https://docs.google.com/presentation/d/1CvNwk11j0MBNNoV4L7irNTVYal2N9uGB0SVWLuZ5NuU/copy" target="_blank">1LNG 2nd Edition - Plant and Animal Traits Student Journal - SPANISH</a></li>
        </ul>
        <ul>
          <li><a href="https://firebasestorage.googleapis.com/v0/b/ccs-dev-926a6.appspot.com/o/unitUpdates%2F1LNG-2E_PostAssessment_06132022.pdf?alt=media&token=bf31ffdf-a5d5-4cd3-a9c4-c19f5922fe5c" target="_blank">1LNG Second Edition Post Assessment - Updated 5/31/2022</a></li>
          <li><a href="https://firebasestorage.googleapis.com/v0/b/ccs-dev-926a6.appspot.com/o/unitUpdates%2F1LNG-2E_Spanish_PostAssessment_06102022.pdf?alt=media&token=eecf1e64-9f9a-4927-9c49-e636e807de45" target="_blank">1LNG Second Edition Post Assessment (Spanish) - Updated 5/31/2022</a></li>
        </ul>
      </div>
      <div class="presentations">
        <h4>Individual Resources</h4>
        
        <p>The resources below are also linked in the Teacher Led Presentations. We've provided them here for anyone wishing to have access to these individual resources outside of the presentations. Please make master copies and save in your Google drive for your classroom.</p>
        <h4 style="margin-left: 10px;">Charts, Handouts, Card Sets, etc.</h4>
        <ul>
          <li><a href="https://drive.google.com/file/d/1_TzNXZz3KhbgiC7SO9n8yuf2Ykjhsjrv/view?usp=sharing" target="_blank">Image of a Fiddler Crab</a></li>
          <li><a href="https://docs.google.com/presentation/d/1qzRl4hopo4tHYFZfGsT1Y6Wl-X10_9iyeIsQWpNJgBQ/copy" target="_blank">What We Think Chart</a></li>
          <li><a href="https://docs.google.com/presentation/d/1aZewXLNVOn0SJN_W8QB6demBnnvQgLUebT4ajvKmjLU/copy" target="_blank">When We Make Observations, We...</a></li>
          <li><a href="https://docs.google.com/presentation/d/1KFbYKmmizqBg5mLXdcM77o0UpDob5D-NEdPtu_VlVUA/copy" target="_blank">Word Wall</a></li>
          <li><a href="https://docs.google.com/presentation/d/1AenKE7lyEEl6JY_6aBP0ohSKsBGgs1ysiJ4Ghhq5j5E/copy" target="_blank">Fiddler Crab Observation Log</a></li>
          <li><a href="https://docs.google.com/presentation/d/17Kvm2oM0UFMudFnlj4B77QhF4KR4uRi1jxgQ7SgGXPs/copy" target="_blank">Fiddler Crab Anatomy Card</a></li>
          <li><a href="https://docs.google.com/presentation/d/1srYzA6jKIoDvNlJtGWBfoI828d1utm51JAB7l6-dPlQ/copy" target="_blank">Tool Analogies Card Set</a></li>
          <li><a href="https://docs.google.com/presentation/d/1yqnUn9fqJyfk4OnPJ_yutTVC20a2d8rbz-uUNJVrkgY/copy" target="_blank">Fiddler Crab Structure and Function Chart</a></li>
          <li><a href="https://docs.google.com/presentation/d/16ieac-VVuM0_omx01MfEQkmqehTezTkRUVHtzqL2nwU/copy" target="_blank">Blue Heron Structure and Function Chart</a></li>
          <li><a href="https://docs.google.com/presentation/d/1j3p5OuOJtOm954Fovb-7cISM0XTyQ9WutQhILMFEfWo/copy" target="_blank">Word Sort Cards - Lesson 2C</a></li>
          <li><a href="https://docs.google.com/presentation/d/1YdbQGwV6ocen3N2-ACLhvFaL6aia2hTX1w_YcLrqd7c/copy" target="_blank">Plant Structure and Function Chart</a></li>
          <li><a href="https://docs.google.com/presentation/d/1ltLQ-Y6dnBhLH2D4X9iVzoJ1q07ON0Mw5bbl8g-3oP8/copy" target="_blank">Plant and Animal Card set</a></li>
          <li><a href="https://docs.google.com/presentation/d/1pwWB4k1bcjBPUfzlwTAbHzA4K3E5DLpi_BwxEeeas_A/copy" target="_blank">Word Sort Cards - Lesson 3B</a></li>
          <li><a href="https://docs.google.com/presentation/d/1nlW_5wNpwwqCuSSjSM0gWqpJP3fuAEt9k_VzKkOnQWM/copy" target="_blank">Using Plant & Animal Structures to Solve Problems Product Descriptor</a></li>
          <li><a href="https://docs.google.com/presentation/d/1F6Z_aYFbW1bp8rNS8Xdaqu8fHfHINrkciBJZMUaUL_M/copy" target="_blank">Life Cycles (Handouts)</a></li>
          <!-- <li><a href="" target="_blank"></a></li> -->

        </ul>

        <h4 style="margin-left: 10px;">Videos</h4>
        <ul>
          <li><a href="https://drive.google.com/file/d/1qmJ8JEpkFQrCaTqjTv56JsBfjYwLbxJH/view?usp=sharing" target="_blank">Fiddler Crabs in the Classroom Habitat</a></li>
        </ul>
      </div>
    </div>
    
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  data() {
    return {}
  },
  computed: {
    ...mapState([ 'dashboardView', 'userProfile' ])
  },
  methods: {
    cancelButton() {
      this.$store.commit('SET_DASHBOARD_VIEW', 'units')
    }
  },
  mounted () {
    window.scrollTo(0, 0)
  }
}
</script>

<style lang="css" scoped>
.presentations {
  border: 1px solid grey;
  text-align: left;
  padding: 20px;
  margin: 0 20px 20px 20px;
}
ul {
  list-style: none;
}
.presentations a {
  margin-left: 40px;
}
li {
  margin-left: -40px;
}
.back-button-wrapper {
  width: 100%;
  text-align: left;
  margin-bottom: 0;
}
.back-button {
  background: white;
  border: none;
  font-weight: 600;
  color: #7b8a1d;
  margin-left: 20px;
}
</style>
